import React, { useState } from "react";
import Button from "../../common/Button/Button";
import SadaqatNews1 from "./sadaqatnews1";
import TeachersDayGallery from "./TeachersDayGallery";
import SadaqatDanishGallery from "./SadaqatDanishGallery";
import SadaqatClosingGallery from "./SadaqatClosingGallery";
import myVideo from '../../videos/carpet.mp4';
import myVideo1 from '../../videos/futsalnews1.mp4';

import './News.css';

const MakeAnImpact = () => {
  const [copySuccess, setCopySuccess] = useState(false);
  const [isSadaqatNews1Open, setIsSadaqatNews1Open] = useState(false);
  const [isTeachersDayGalleryOpen, setIsTeachersDayGalleryOpen] = useState(false);
  const [isSadaqatDanishGalleryOpen, setIsSadaqatDanishGalleryOpen] = useState(false);
  const [isSadaqatClosingGalleryOpen, setIsSadaqatClosingGalleryOpen] = useState(false);

  const openSadaqatNews1 = () => setIsSadaqatNews1Open(true);
  const openTeachersDayGallery = () => setIsTeachersDayGalleryOpen(true);
  const openSadaqatDanishGallery = () => setIsSadaqatDanishGalleryOpen(true);
  const openSadaqatClosingGallery = () => setIsSadaqatClosingGalleryOpen(true);

  const sharePage = () => {
    const shareData = {
      title: "Share the Good News",
      url: "https://actionnotword.org/news",
    };

    if (navigator.share) {
      navigator.share(shareData)
        .then(() => console.log('Page shared successfully!'))
        .catch((error) => console.error('Error sharing:', error));
    } else {
      navigator.clipboard.writeText(shareData.url)
        .then(() => {
          setCopySuccess(true);
          setTimeout(() => setCopySuccess(false), 5000);
        })
        .catch((error) => console.error('Failed to copy URL:', error));
    }
  };

  return (
    <div>
      {isSadaqatNews1Open && (
        <SadaqatNews1 isOpen={isSadaqatNews1Open} setIsOpen={setIsSadaqatNews1Open} />
      )}
      {isTeachersDayGalleryOpen && (
        <TeachersDayGallery isOpen={isTeachersDayGalleryOpen} setIsOpen={setIsTeachersDayGalleryOpen} />
      )}
      {isSadaqatDanishGalleryOpen && (
        <SadaqatDanishGallery isOpen={isSadaqatDanishGalleryOpen} setIsOpen={setIsSadaqatDanishGalleryOpen} />
      )}
      {isSadaqatClosingGalleryOpen && (
        <SadaqatClosingGallery isOpen={isSadaqatClosingGalleryOpen} setIsOpen={setIsSadaqatClosingGalleryOpen} />
      )}

      {/* Article 1 */}
      <div className="makeAnImpact" data-aos="fade-up" data-aos-delay="100">
        <h1>Sedaqat & Danish Closing</h1>
        <div className="donateSection">
          <p>
            The closing ceremony of Sedaqat & Danish was marked by a bittersweet feeling, as we celebrated both an ending and the 
            achievements of our students. The event was filled with joy, pride, and a strong sense of accomplishment as students 
            were recognized for their hard work and dedication.
            A special thanks to Mirwais Khan and his team for organizing such a memorable and meaningful ceremony. 
            Their efforts made this occasion truly unforgettable for our students.
          </p>
          <div className="hero-btns">
            <div className="hero-btn-group">
              <Button
                className="btns"
                buttonStyle="btn--primary"
                buttonSize="btn--large"
                onClick={openSadaqatClosingGallery}
              >
                View Photos
              </Button>
              <button className="shareButton" onClick={sharePage}>
                Share This Story
              </button>
            </div>
            {copySuccess && <div className="copySuccessMessage">✓ Link copied to clipboard!</div>}
          </div>
        </div>
      </div>

      {/* Article 1 */}
      <div className="makeAnImpact" data-aos="fade-up" data-aos-delay="100">
        <h1>A Fun and Educational Field Trip for Sedaqat & Danish Students</h1>
        <div className="donateSection">
          <p>
            With the combined efforts of our dedicated teachers and supportive parents, the students of Sedaqat
            & Danish Educational Center had the opportunity to embark on an exciting field trip. They visited
            some of Kabul's most iconic sites: the Kabul Zoo, the National Museum, and the breathtaking Babur Garden.
            <br/><br/>
            Throughout the day, the students not only explored the wonders of nature and history but also had
            an amazing time filled with fun and laughter. It was an enriching experience for everyone involved,
            as they connected with both their surroundings and each other.
            <br/><br/>
            Such activities are a vital part of our educational philosophy, where we believe that learning
            extends beyond the classroom. We look forward to organizing more events that combine education,
            exploration, and enjoyment for our students.
          </p>
          <div className="hero-btns">
            <div className="hero-btn-group">
              <Button
                className="btns"
                buttonStyle="btn--primary"
                buttonSize="btn--large"
                onClick={openSadaqatDanishGallery}
              >
                View Photos
              </Button>
              <button className="shareButton" onClick={sharePage}>
                Share This Story
              </button>
            </div>
            {copySuccess && <div className="copySuccessMessage">✓ Link copied to clipboard!</div>}
          </div>
        </div>
      </div>

      {/* Article 2 */}
      <div className="makeAnImpact" data-aos="fade-up" data-aos-delay="200">
        <h1>Teachers' Day Celebration at One Hour for Afghanistan</h1>
        <div className="donateSection">
          <p>
            On this special occasion of Teachers' Day, we gathered at the One Hour for Afghanistan educational center
            to honor the incredible dedication and hard work of our teachers. They are the backbone of our community,
            inspiring and guiding our students every day.
            <br/><br/>
            The celebration was filled with heartfelt speeches, gratitude, and appreciation for the efforts of our
            educators who continuously strive to empower the next generation through knowledge and wisdom. We also
            presented appreciation letters to our teachers as a token of recognition for their invaluable contributions
            to our mission.
            <br/><br/>
            We are grateful for their passion and commitment to shaping a brighter future for Afghanistan. Thank you, teachers, for being the guiding light in our journey of education and empowerment!
          </p>
          <div className="hero-btns">
            <div className="hero-btn-group">
              <Button
                className="btns"
                buttonStyle="btn--primary"
                buttonSize="btn--large"
                onClick={openTeachersDayGallery}
              >
                View Photos
              </Button>
              <button className="shareButton" onClick={sharePage}>
                Share This Story
              </button>
            </div>
            {copySuccess && <div className="copySuccessMessage">✓ Link copied to clipboard!</div>}
          </div>
        </div>
      </div>

      {/* Article 3 */}
      <div className="makeAnImpact" data-aos="fade-up" data-aos-delay="300">
        <h1>Futsal Tournament, Organized by ANW</h1>
        <div className="donateSection">
          <p>
            The Futsal Tournament, organized by Action Not Words (ANW) members, was a competition specifically
            designed for under-14 boys. The event received financial support from ANW members, showcasing their
            commitment to promoting sports and healthy activities among young participants. The tournament
            served as a platform for youth engagement, fostering teamwork, discipline, and community spirit among
            the under-14 boys.
          </p>
          <div className="videoContainer">
            <div>
              <video controls>
                <source src={myVideo1} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <button className="shareButton" onClick={sharePage}>
            Share This Story
          </button>
          {copySuccess && <div className="copySuccessMessage">✓ Link copied to clipboard!</div>}
        </div>
      </div>

      {/* Article 4 */}
      <div className="makeAnImpact" data-aos="fade-up" data-aos-delay="400">
        <h1>Certificate Distribution Ceremony at Sedaqat & Danish Education Centers</h1>
        <div className="donateSection">
          <p>
            On August 28, 2024, Sedaqat and Danish Education Centers held a ceremony to honor our top students with
            certificates of achievement. The event recognized the hard work and dedication of our best-performing
            students, celebrating their academic success.
            <br/><br/>
            Teachers, parents, and guests attended the ceremony, adding to the significance of the occasion.
            This event highlighted our ongoing commitment to excellence in education and the bright future of our students.
          </p>
          <div className="hero-btns">
            <div className="hero-btn-group">
              <Button
                className="btns"
                buttonStyle="btn--primary"
                buttonSize="btn--large"
                onClick={openSadaqatNews1}
              >
                View Photos
              </Button>
              <button className="shareButton" onClick={sharePage}>
                Share This Story
              </button>
            </div>
            {copySuccess && <div className="copySuccessMessage">✓ Link copied to clipboard!</div>}
          </div>
        </div>
      </div>

      {/* Article 5 */}
      <div className="makeAnImpact" data-aos="fade-up" data-aos-delay="500">
        <h1>Carpets & Foam Mats for Four Classrooms of a Girls' School</h1>
        <div className="donateSection">
          <p>
            Respected Ahmad Shah Fazel, a family member of Nader Jan Omar, generously provided $300
            to assist deserving schools. As part of my responsibility, I purchased carpets and foam mats
            for four classrooms of a girls' school that previously lacked proper flooring. The students
            are now benefiting from this contribution.
            <br/><br/>
            Special thanks to Ahmad Shah Fazel and Nader Jan Omar for facilitating this support!
          </p>
          <div className="videoContainer">
            <div>
              <video controls>
                <source src={myVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <button className="shareButton" onClick={sharePage}>
            Share This Story
          </button>
          {copySuccess && <div className="copySuccessMessage">✓ Link copied to clipboard!</div>}
        </div>
      </div>

      {/* Article 6 */}
      <div className="makeAnImpact" data-aos="fade-up" data-aos-delay="600">
        <h1>Eid al-Adha Program</h1>
        <div className="donateSection">
          <p>
            In celebration of Eid al-Adha, sweets were distributed among students of Sedaqat education center. 
            In the meantime, students who completed the first level of English language arts class received their 
            certificates of completion.
            <br/><br/>
            This is awesome and seeing the happiness in children's faces is priceless. In my opinion, this is 
            the best kind of Qurbani and Hajj. Eid Mubarak and Hajj and Qurbani qabool!
          </p>
          <button className="shareButton" onClick={sharePage}>
            Share This Story
          </button>
          {copySuccess && <div className="copySuccessMessage">✓ Link copied to clipboard!</div>}
        </div>
      </div>
    </div>
  );
};

export default MakeAnImpact;
